/**
 * EliteCart renders in an open shadow root; theme stylesheets cannot reach .ec-* classes.
 * Inject elitecart-button-hover.css into the shadow tree only — no cart API or event interception.
 */
(function () {
  const script = document.currentScript;
  const cssHref = script?.dataset?.cssHref;

  if (!cssHref) {
    return;
  }

  const LINK_ID = 'theme-elitecart-button-hover';

  /** @returns {boolean} */
  function injectStylesheet() {
    const root = window.eliteCartDocumentOrShadowRoot;

    if (!root) {
      return false;
    }

    if (root.getElementById?.(LINK_ID) || root.querySelector?.(`#${LINK_ID}`)) {
      return true;
    }

    const link = document.createElement('link');
    link.id = LINK_ID;
    link.rel = 'stylesheet';
    link.href = cssHref;
    root.appendChild(link);
    return true;
  }

  /** @type {MutationObserver | undefined} */
  let observer;

  function tryInject() {
    if (injectStylesheet()) {
      observer?.disconnect();
    }
  }

  document.addEventListener('eliteCartUpdated', tryInject, { passive: true });

  if (document.body) {
    observer = new MutationObserver(tryInject);
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        observer = new MutationObserver(tryInject);
        observer.observe(document.body, { childList: true, subtree: true });
        tryInject();
      },
      { once: true }
    );
  }

  tryInject();
  window.setTimeout(() => observer?.disconnect(), 15000);
})();
